module.exports = __webpack_public_path__ + "img/praca-estudantes.d49e1e49.jpg";